
export default function timeoutAsync(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}